/**
 * Rotas do módulo Metas (E22).
 *
 * Cada página tem seu **sub-recurso** de permissão (padrão `documentos_*`), e
 * não a permissão de operação: quem só lê precisa alcançar a tela; quem
 * cadastra tem `metas:create` além disso. Gatear a página pela operação
 * esconderia a tela de quem tem direito de vê-la.
 *
 * | Rota                | Gate                      | Quem usa            |
 * |---------------------|---------------------------|---------------------|
 * | `/metas`            | `metas_listagem:view`     | todos do módulo     |
 * | `/metas/cadastro`   | `metas_cadastro:view`     | coordenador         |
 * | `/metas/produtos`   | `metas_produtos:view`     | coordenador/admin   |
 * | `/metas/importar`   | `metas:import`            | coordenador         |
 * | `/metas/mapeamento` | `metas_mapeamento:view`   | admin               |
 * | `/metas/conexao`    | `metas_conexao:view`      | admin do sistema    |
 * | `/metas/sync`       | `metas_sync:view`         | coordenador/admin   |
 */
import { lazy } from "react";

import { ModuleRoutes } from "../types";

const MetasListPage = lazy(() => import("@/pages/metas/MetasListPage"));
const MetasCadastroPage = lazy(() => import("@/pages/metas/MetasCadastroPage"));
const MetasProdutosPage = lazy(() => import("@/pages/metas/MetasProdutosPage"));
const MetasMapeamentoPage = lazy(() => import("@/pages/metas/MetasMapeamentoPage"));
const MetasConexaoPage = lazy(() => import("@/pages/metas/MetasConexaoPage"));
const MetasSyncPage = lazy(() => import("@/pages/metas/MetasSyncPage"));
// Mesma página de `/admin/import-wizard`. Ela é genérica: lista os módulos que
// o backend devolve, e o backend já filtra por permissão — o coordenador que
// entrar por aqui só enxerga "Metas de Substabelecido".
const ImportWizardPage = lazy(() => import("@/pages/admin/ImportWizardPage"));

export const metasRoutes: ModuleRoutes = {
  moduleId: "metas",
  basePath: "/metas",
  routes: [
    {
      path: "/metas",
      element: <MetasListPage />,
      permission: { resource: "metas_listagem", action: "view" },
    },
    {
      path: "/metas/cadastro",
      element: <MetasCadastroPage />,
      permission: { resource: "metas_cadastro", action: "view" },
    },
    {
      path: "/metas/produtos",
      element: <MetasProdutosPage />,
      permission: { resource: "metas_produtos", action: "view" },
    },
    {
      // O coordenador de metas NÃO tem `admin:access`, que é o gate de
      // `/admin/import-wizard`. Sem esta rota ele teria a permissão de importar
      // e nenhuma tela para exercê-la — ou precisaria receber acesso ao módulo
      // Admin inteiro só para subir uma planilha.
      path: "/metas/importar",
      element: <ImportWizardPage />,
      permission: { resource: "metas", action: "import" },
    },
    {
      path: "/metas/mapeamento",
      element: <MetasMapeamentoPage />,
      permission: { resource: "metas_mapeamento", action: "view" },
    },
    {
      path: "/metas/conexao",
      element: <MetasConexaoPage />,
      permission: { resource: "metas_conexao", action: "view" },
    },
    {
      path: "/metas/sync",
      element: <MetasSyncPage />,
      permission: { resource: "metas_sync", action: "view" },
    },
  ],
};
